import {groq} from 'next-sanity';

import type {ContentBlockFragment} from '@/modules/foundation/sanity/content-blocks/query';
import {CONTENT_BLOCK_FRAGMENT} from '@/modules/foundation/sanity/content-blocks/query';
import type {PageHeadFragment} from '@/modules/foundation/sanity/page-head/query';
import {PAGE_HEAD_FRAGMENT} from '@/modules/foundation/sanity/page-head/query';
import {DOCUMENT_TYPE_PAGE} from '@/modules/page/sanity/page/constants';
import type {SanityArray} from '@/sanity/lib/types';

import {type PageSchema} from './schema';

export const PAGE_FRAGMENT = groq`
	...,
	pageHeadings[]{
		${PAGE_HEAD_FRAGMENT}
	},
	content[]{
		${CONTENT_BLOCK_FRAGMENT}
	},
`;

export type PageFragment = Omit<PageSchema, 'content' | 'pageHeadings'> & {
	pageHeadings?: SanityArray<PageHeadFragment>;
	content?: SanityArray<ContentBlockFragment>;
};

/**
 * Fetches the content of a page by its slug.
 * Returns all of the content associated with the page.
 */
export const PAGE_BY_SLUG_QUERY = groq`
*[_type == "${DOCUMENT_TYPE_PAGE}" && slug.current == $slug][0]{
	${PAGE_FRAGMENT}
}
`;

export type PageBySlugQueryResult = PageFragment | null;
